var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41161 15.61C7.19461 15.4029 7.0861 15.1354 7.0861 14.8075C7.0861 14.4796 7.20295 14.1948 7.43665 13.9532L12.0689 9.16406H1.12679C0.809629 9.16406 0.542545 9.0562 0.325539 8.84047C0.108533 8.62474 3.05176e-05 8.33567 3.05176e-05 7.97325C3.05176e-05 7.64535 0.108533 7.36922 0.325539 7.14486C0.542545 6.9205 0.809629 6.80833 1.12679 6.80833H12.0689L7.43665 1.99331C7.20295 1.78621 7.0861 1.5144 7.0861 1.17787C7.0861 0.841333 7.19461 0.560889 7.41161 0.336533C7.64531 0.112178 7.91657 0 8.22538 0C8.5342 0 8.80546 0.112178 9.03915 0.336533L15.6495 7.17075C15.7663 7.2743 15.854 7.3951 15.9124 7.53317C15.9708 7.67123 16 7.81793 16 7.97325C16 8.14583 15.9708 8.30115 15.9124 8.43922C15.854 8.57728 15.7663 8.70672 15.6495 8.82753L9.03915 15.6617C8.80546 15.9034 8.5342 16.0155 8.22538 15.9983C7.91657 15.981 7.64531 15.8516 7.41161 15.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow-forward.f04e0ce7ba25187cb0ceebc052c6637c.svg";
export { ForwardRef as ReactComponent };